import { request } from '@/utils/request';
import {
  LocaleParams,
} from '@/utils/request.types';
import { addRequestFieldsToObject } from '@/utils/helpers';

import {
  ArticleDataResponse,
  ArticleLinksRequest,
  ArticleRequest,
  ArticleTopicRequest,
  FeaturedArticlesResponse,
} from './Articles.types';

export const api = {
  getArticle: ({
    slug,
    ...params
  }: ArticleRequest) => request.get<ArticleDataResponse>('/articles', {
    params: {
      ...params,
      'filters[slug][$eq]': slug,
    },
    withCredentials: false,
  }, true),
  getArticlePage: (params: ArticleLinksRequest) => request.get('/article-page', {
    params,
    withCredentials: false,
  }, true),
  getArticles: (params: ArticleLinksRequest) => request.get<ArticleDataResponse>('/articles', {
    params: {
      populate: [
        'image',
        'topics',
      ],
      ...addRequestFieldsToObject([
        'title',
        'subtitle',
        'readingTime',
        'createdAt',
        'slug',
      ]),
      ...params,
    },
    withCredentials: false,
  }),
  // TODO add article types
  getFeaturedArticles: (params: LocaleParams & { 'sort[createdAt]'?: string }) => request.get<FeaturedArticlesResponse>('/articles?filters[featured][$eq]=true',
    {
      params: {
        ...params,
        populate: [
          'image',
          'topics',
        ],
      },
      withCredentials: false,
    }, true),
  getTopics: (params: ArticleTopicRequest) => request.get('/topics', {
    params,
    withCredentials: false,
  }),

};
